export default {
    list: [
        {
            "id": "1712558913136",
            "parent_id": null,
            "name": "VERTEX",
            "sort": 0,
            "create_time": "2026-03-18T02:40:01.000Z",
            "children": [
               {
                "id": "1773801706461",
                "name": "Attrezzature di Frantumazione",
                "children": [
                    {
                    "name": "Frantoio Giratorio",
                    "children": [
                        {
                        "name": "Frantoio Giratorio Serie HGT",
                        "children": [
                            { "name": "HGT4265" },
                            { "name": "HGT5065" }
                        ]
                        }
                    ]
                    },
                    {
                    "name": "Frantoio a Mascelle",
                    "children": [
                        {
                        "name": "Frantoio a Mascelle Serie C6X"
                        },
                        {
                        "name": "Frantoio a Mascelle Serie C5X",
                        "children": [
                            { "name": "C6X80" },
                            { "name": "C6X100" },
                            { "name": "C6X110" },
                            { "name": "C6X125" },
                            { "name": "C6X145" },
                            { "name": "C6X160" }
                        ]
                        },
                        {
                        "name": "Frantoio a Mascelle Serie PEW",
                        "children": [
                            { "name": "PEW760" },
                            { "name": "PEW860" }
                        ]
                        },
                        {
                        "name": "Frantoio a Mascelle Serie PE",
                        "children": [
                            { "name": "PE600x900" },
                            { "name": "PE750x1060" },
                            { "name": "PE900x1200" },
                            { "name": "PE1000x1200" },
                            { "name": "PE1200x1500(003)" },
                            { "name": "PE1200x1500(001)" }
                        ]
                        }
                    ]
                    },
                    {
                    "name": "Frantoio a Impatto",
                    "children": [
                        {
                        "name": "Frantoio a Impatto Serie CI5X",
                        "children": [
                            { "name": "CI5X1213" },
                            { "name": "CI5X1315(001)" },
                            { "name": "CI5X1315(003)" },
                            { "name": "CI5X1415 (Vendita di prova)" },
                            { "name": "CI5X1520" },
                            { "name": "CI5X1524" },
                            { "name": "CI5X1620 (Vendita di prova)" },
                            { "name": "CI5X1630 (Vendita di prova)" },
                            { "name": "CI5X2030 (Vendita di prova)" }
                        ]
                        },
                        {
                        "name": "Frantoio a Impatto Serie PFW",
                        "children": [
                            { "name": "PFW1214 II (Fuori produzione)" },
                            { "name": "PFW1315 II (Fuori produzione)" },
                            { "name": "PFW1318 II (Fuori produzione)" },
                            { "name": "PFW1415 II (Fuori produzione)" },
                            { "name": "PFW1214 III" },
                            { "name": "PFW1315 III" },
                            { "name": "PFW1318 III (Fuori produzione)" },
                            { "name": "PFW1415 III" }
                        ]
                        },
                        {
                        "name": "Frantoio a Impatto Serie PF",
                        "children": [
                            { "name": "PF1010" },
                            { "name": "PF1210" },
                            { "name": "PF1214" },
                            { "name": "PF1315" }
                        ]
                        }
                    ]
                    },
                    {
                    "name": "Frantoio a Cono",
                    "children": [
                        {
                        "name": "Frantoio a Cono Idraulico Multicilindro Serie HPT",
                        "children": [
                            { "name": "HPT300" },
                            { "name": "HPT500" },
                            { "name": "HPT800 (Vendita di prova)" }
                        ]
                        },
                        {
                        "name": "Frantoio a Cono Idraulico Monocilindro Serie HST",
                        "children": [
                            { "name": "HST100H" },
                            { "name": "HST100S" },
                            { "name": "HST160H" },
                            { "name": "HST160S" },
                            { "name": "HST250H" },
                            { "name": "HST250S" },
                            { "name": "HST315H" },
                            { "name": "HST315S" },
                            { "name": "HST450S (Vendita di prova)" },
                            { "name": "HST600H (Vendita di prova)" },
                            { "name": "HST750H (Vendita di prova)" }
                        ]
                        }
                    ]
                    },
                    {
                    "name": "Frantoio a Impatto ad Albero Verticale",
                    "children": [
                        {
                        "name": "Frantoio VSI Serie VSI6X",
                        "children": [
                            { "name": "VSI6X8015" },
                            { "name": "VSI6X9026" },
                            { "name": "VSI6X1040" },
                            { "name": "VSI6X1150" },
                            { "name": "VSI6X1263" },
                            { "name": "VSI6X1150G" },
                            { "name": "VSI6X1263G" },
                            { "name": "VSI6X1380G" },
                            { "name": "VSI6X13100G" },
                            { "name": "VSI6X1040Z (Vendita di prova)" },
                            { "name": "VSI6X1150Z (Vendita di prova)" },
                            { "name": "VSI6X1263Z (Vendita di prova)" }
                        ]
                        },
                        {
                        "name": "Frantoio VSI Serie VSI5X",
                        "children": [
                            { "name": "VSI5X7615" },
                            { "name": "VSI5X8522" },
                            { "name": "VSI5X9532" },
                            { "name": "VSI5X1145" }
                        ]
                        },
                        {
                        "name": "Frantoio VSI Serie VSI",
                        "children": [
                            { "name": "VSI7611" },
                            { "name": "VSI8518" },
                            { "name": "VSI9526" },
                            { "name": "VSI1140" }
                        ]
                        }
                    ]
                    }
                ]
                },
                {
                "id": "1773801854300",
                "parent_id": "1712558913136",
                "name": "Attrezzature di Alimentazione e Vaglio",
                "sort": 0,
                "create_time": "2026-03-18T02:44:14.000Z",
                "children": [
                    {
                    "id": "1773801869576",
                    "parent_id": "1773801854300",
                    "name": "Alimentatore",
                    "sort": 0,
                    "create_time": "2026-03-18T02:44:30.000Z",
                    "children": [
                        {
                        "id": "1773801893890",
                        "parent_id": "1773801869576",
                        "name": "Alimentatore Vibrante Serie F5X",
                        "sort": 0,
                        "create_time": "2026-03-18T02:44:54.000Z",
                        "children": [
                            { "id": "1773803506416", "parent_id": "1773801893890", "name": "F5X1045", "sort": 0, "create_time": "2026-03-18T03:11:46.000Z" },
                            { "id": "1773803512714", "parent_id": "1773801893890", "name": "F5X1045M", "sort": 0, "create_time": "2026-03-18T03:11:53.000Z" },
                            { "id": "1773803517503", "parent_id": "1773801893890", "name": "F5X1345", "sort": 0, "create_time": "2026-03-18T03:11:57.000Z" },
                            { "id": "1773803524211", "parent_id": "1773801893890", "name": "F5X1345M", "sort": 0, "create_time": "2026-03-18T03:12:04.000Z" },
                            { "id": "1773803530209", "parent_id": "1773801893890", "name": "F5X1360", "sort": 0, "create_time": "2026-03-18T03:12:10.000Z" },
                            { "id": "1773803535346", "parent_id": "1773801893890", "name": "F5X1360S", "sort": 0, "create_time": "2026-03-18T03:12:15.000Z" },
                            { "id": "1773803540542", "parent_id": "1773801893890", "name": "F5X1645", "sort": 0, "create_time": "2026-03-18T03:12:20.000Z" },
                            { "id": "1773803546967", "parent_id": "1773801893890", "name": "F5X1645M", "sort": 0, "create_time": "2026-03-18T03:12:27.000Z" },
                            { "id": "1773803552374", "parent_id": "1773801893890", "name": "F5X1660", "sort": 0, "create_time": "2026-03-18T03:12:32.000Z" },
                            { "id": "1773803562353", "parent_id": "1773801893890", "name": "F5X1660S", "sort": 0, "create_time": "2026-03-18T03:12:42.000Z" },
                            { "id": "1773803566723", "parent_id": "1773801893890", "name": "F5X2060", "sort": 0, "create_time": "2026-03-18T03:12:47.000Z" }
                        ]
                        },
                        {
                        "id": "1773801903454",
                        "parent_id": "1773801869576",
                        "name": "Alimentatore Vibrante Serie F5X-G",
                        "sort": 0,
                        "create_time": "2026-03-18T02:45:03.000Z"
                        },
                        {
                        "id": "1773801910609",
                        "parent_id": "1773801869576",
                        "name": "Alimentatore Vibrante Serie GF",
                        "sort": 0,
                        "create_time": "2026-03-18T02:45:11.000Z",
                        "children": [
                            { "id": "1773803461308", "parent_id": "1773801910609", "name": "GF0942", "sort": 0, "create_time": "2026-03-18T03:11:01.000Z" },
                            { "id": "1773803467375", "parent_id": "1773801910609", "name": "GF0942M", "sort": 0, "create_time": "2026-03-18T03:11:07.000Z" },
                            { "id": "1773803471949", "parent_id": "1773801910609", "name": "GF0942S", "sort": 0, "create_time": "2026-03-18T03:11:12.000Z" },
                            { "id": "1773803477634", "parent_id": "1773801910609", "name": "GF1245", "sort": 0, "create_time": "2026-03-18T03:11:18.000Z" },
                            { "id": "1773803481949", "parent_id": "1773801910609", "name": "GF1245M", "sort": 0, "create_time": "2026-03-18T03:11:22.000Z" },
                            { "id": "1773803486862", "parent_id": "1773801910609", "name": "GF1245S", "sort": 0, "create_time": "2026-03-18T03:11:27.000Z" }
                        ]
                        },
                        {
                        "id": "1773801919626",
                        "parent_id": "1773801869576",
                        "name": "Alimentatore Vibrante Serie SP",
                        "sort": 0,
                        "create_time": "2026-03-18T02:45:20.000Z",
                        "children": [
                            { "id": "1773803414870", "parent_id": "1773801919626", "name": "SP0816", "sort": 0, "create_time": "2026-03-18T03:10:15.000Z" },
                            { "id": "1773803419760", "parent_id": "1773801919626", "name": "SP0816Z", "sort": 0, "create_time": "2026-03-18T03:10:20.000Z" },
                            { "id": "1773803424330", "parent_id": "1773801919626", "name": "SP1220", "sort": 0, "create_time": "2026-03-18T03:10:24.000Z" },
                            { "id": "1773803429862", "parent_id": "1773801919626", "name": "SP1220Z", "sort": 0, "create_time": "2026-03-18T03:10:30.000Z" },
                            { "id": "1773803434941", "parent_id": "1773801919626", "name": "SP1623Z", "sort": 0, "create_time": "2026-03-18T03:10:35.000Z" }
                        ]
                        }
                    ]
                    },
                    {
                    "id": "1773802262481",
                    "parent_id": "1773801854300",
                    "name": "Vaglio Vibrante",
                    "sort": 0,
                    "create_time": "2026-03-18T02:51:02.000Z",
                    "children": [
                        {
                        "id": "1773802283369",
                        "parent_id": "1773802262481",
                        "name": "Vaglio Vibrante Serie S5X",
                        "sort": 0,
                        "create_time": "2026-03-18T02:51:23.000Z",
                        "children": [
                            { "id": "1773803141948", "parent_id": "1773802283369", "name": "S5X1545-2", "sort": 0, "create_time": "2026-03-18T03:05:42.000Z" },
                            { "id": "1773803146502", "parent_id": "1773802283369", "name": "S5X1545-3", "sort": 0, "create_time": "2026-03-18T03:05:46.000Z" },
                            { "id": "1773803151012", "parent_id": "1773802283369", "name": "S5X1845-2", "sort": 0, "create_time": "2026-03-18T03:05:51.000Z" },
                            { "id": "1773803155112", "parent_id": "1773802283369", "name": "S5X1845-3", "sort": 0, "create_time": "2026-03-18T03:05:55.000Z" },
                            { "id": "1773803160147", "parent_id": "1773802283369", "name": "S5X1860-2", "sort": 0, "create_time": "2026-03-18T03:06:00.000Z" },
                            { "id": "1773803165052", "parent_id": "1773802283369", "name": "S5X1860-3", "sort": 0, "create_time": "2026-03-18T03:06:05.000Z" },
                            { "id": "1773803169379", "parent_id": "1773802283369", "name": "S5X1860-4", "sort": 0, "create_time": "2026-03-18T03:06:09.000Z" },
                            { "id": "1773803176346", "parent_id": "1773802283369", "name": "S5X2160-2", "sort": 0, "create_time": "2026-03-18T03:06:16.000Z" },
                            { "id": "1773803199726", "parent_id": "1773802283369", "name": "S5X2160-3", "sort": 0, "create_time": "2026-03-18T03:06:40.000Z" },
                            { "id": "1773803204406", "parent_id": "1773802283369", "name": "S5X2160-4", "sort": 0, "create_time": "2026-03-18T03:06:44.000Z" },
                            { "id": "1773803209026", "parent_id": "1773802283369", "name": "S5X2460-2", "sort": 0, "create_time": "2026-03-18T03:06:49.000Z" },
                            { "id": "1773803213868", "parent_id": "1773802283369", "name": "S5X2460-3", "sort": 0, "create_time": "2026-03-18T03:06:54.000Z" },
                            { "id": "1773803217895", "parent_id": "1773802283369", "name": "S5X2460-4", "sort": 0, "create_time": "2026-03-18T03:06:58.000Z" },
                            { "id": "1773803222326", "parent_id": "1773802283369", "name": "S5X2760-2", "sort": 0, "create_time": "2026-03-18T03:07:02.000Z" },
                            { "id": "1773803227831", "parent_id": "1773802283369", "name": "S5X2760-3", "sort": 0, "create_time": "2026-03-18T03:07:08.000Z" },
                            { "id": "1773803236214", "parent_id": "1773802283369", "name": "S5X3072-2", "sort": 0, "create_time": "2026-03-18T03:07:16.000Z" },
                            { "id": "1773803241950", "parent_id": "1773802283369", "name": "S5X3075-2T", "sort": 0, "create_time": "2026-03-18T03:07:22.000Z" },
                            { "id": "1773803248471", "parent_id": "1773802283369", "name": "S5X3075-3T", "sort": 0, "create_time": "2026-03-18T03:07:28.000Z" },
                            { "id": "1773803307856", "parent_id": "1773802283369", "name": "S5X3680-2T6", "sort": 0, "create_time": "2026-03-18T03:08:28.000Z" },
                            { "id": "1773803316682", "parent_id": "1773802283369", "name": "S5X3680-3T", "sort": 0, "create_time": "2026-03-18T03:08:37.000Z" },
                            { "id": "1773803328697", "parent_id": "1773802283369", "name": "S5X3685-2T (Vendita di prova)", "sort": 0, "create_time": "2026-03-18T03:08:49.000Z" },
                            { "id": "1773803338328", "parent_id": "1773802283369", "name": "S5X3685-3T (Vendita di prova)", "sort": 0, "create_time": "2026-03-18T03:08:58.000Z" }
                        ]
                        },
                        {
                        "id": "1773802292445",
                        "parent_id": "1773802262481",
                        "name": "Vaglio Vibrante Serie Y",
                        "sort": 0,
                        "create_time": "2026-03-18T02:51:32.000Z",
                        "children": [
                            { "id": "1773802931886", "parent_id": "1773802292445", "name": "2Y1237", "sort": 0, "create_time": "2026-03-18T03:02:12.000Z" },
                            { "id": "1773802936044", "parent_id": "1773802292445", "name": "3Y1237", "sort": 0, "create_time": "2026-03-18T03:02:16.000Z" },
                            { "id": "1773802942284", "parent_id": "1773802292445", "name": "4Y1237", "sort": 0, "create_time": "2026-03-18T03:02:22.000Z" },
                            { "id": "1773802947878", "parent_id": "1773802292445", "name": "2Y1548", "sort": 0, "create_time": "2026-03-18T03:02:28.000Z" },
                            { "id": "1773802953962", "parent_id": "1773802292445", "name": "3Y1548", "sort": 0, "create_time": "2026-03-18T03:02:34.000Z" },
                            { "id": "1773802959081", "parent_id": "1773802292445", "name": "4Y1548", "sort": 0, "create_time": "2026-03-18T03:02:39.000Z" },
                            { "id": "1773802964365", "parent_id": "1773802292445", "name": "2Y1848", "sort": 0, "create_time": "2026-03-18T03:02:44.000Z" },
                            { "id": "1773802970066", "parent_id": "1773802292445", "name": "3Y1848", "sort": 0, "create_time": "2026-03-18T03:02:50.000Z" },
                            { "id": "1773802975318", "parent_id": "1773802292445", "name": "4Y1848", "sort": 0, "create_time": "2026-03-18T03:02:55.000Z" },
                            { "id": "1773802980104", "parent_id": "1773802292445", "name": "2Y1860", "sort": 0, "create_time": "2026-03-18T03:03:00.000Z" },
                            { "id": "1773802994939", "parent_id": "1773802292445", "name": "3Y1860", "sort": 0, "create_time": "2026-03-18T03:03:15.000Z" },
                            { "id": "1773802999691", "parent_id": "1773802292445", "name": "4Y1860", "sort": 0, "create_time": "2026-03-18T03:03:20.000Z" },
                            { "id": "1773803027720", "parent_id": "1773802292445", "name": "2Y2160", "sort": 0, "create_time": "2026-03-18T03:03:48.000Z" },
                            { "id": "1773803035016", "parent_id": "1773802292445", "name": "3Y2160", "sort": 0, "create_time": "2026-03-18T03:03:55.000Z" },
                            { "id": "1773803041916", "parent_id": "1773802292445", "name": "4Y2160", "sort": 0, "create_time": "2026-03-18T03:04:02.000Z" },
                            { "id": "1773803047594", "parent_id": "1773802292445", "name": "2Y2460", "sort": 0, "create_time": "2026-03-18T03:04:08.000Z" },
                            { "id": "1773803055337", "parent_id": "1773802292445", "name": "3Y2460", "sort": 0, "create_time": "2026-03-18T03:04:15.000Z" },
                            { "id": "1773803062421", "parent_id": "1773802292445", "name": "4Y2460", "sort": 0, "create_time": "2026-03-18T03:04:22.000Z" }
                        ]
                        }
                    ]
                    }
                ]
                },
                {
                    "id": "1773802326100",
                    "parent_id": "1712558913136",
                    "name": "Macchine Acquistate / Controllo Elettrico / Componenti Standard / Motori / Cuscinetti / Reti di Vaglio (Attrezzature Ausiliarie)",
                    "sort": 0,
                    "create_time": "2026-03-18T02:52:06.000Z",
                    "children": [
                        {
                        "id": "1773802365580",
                        "parent_id": "1773802326100",
                        "name": "Frantoio a Mascelle (Acquistato)",
                        "sort": 0,
                        "create_time": "2026-03-18T02:52:45.000Z",
                        "children": [
                            {
                            "id": "1773802378647",
                            "parent_id": "1773802365580",
                            "name": "Frantoio a Mascelle (PEW/PE)",
                            "sort": 0,
                            "create_time": "2026-03-18T02:52:59.000Z",
                            "children": [
                                { "id": "1773802410459", "parent_id": "1773802378647", "name": "PEW400x600", "sort": 0, "create_time": "2026-03-18T02:53:30.000Z" },
                                { "id": "1773802437546", "parent_id": "1773802378647", "name": "PEW250x1000", "sort": 0, "create_time": "2026-03-18T02:53:57.000Z" },
                                { "id": "1773802453131", "parent_id": "1773802378647", "name": "PEW250x1200", "sort": 0, "create_time": "2026-03-18T02:54:13.000Z" }
                            ]
                            }
                        ]
                        },
                        {
                        "id": "1773802478479",
                        "parent_id": "1773802326100",
                        "name": "Frantoio a Cono (Acquistato)",
                        "sort": 0,
                        "create_time": "2026-03-18T02:54:38.000Z",
                        "children": [
                            {
                            "id": "1773802501681",
                            "parent_id": "1773802478479",
                            "name": "Frantoio a Cono Serie CS",
                            "sort": 0,
                            "create_time": "2026-03-18T02:55:02.000Z",
                            "children": [
                                { "id": "1773802634435", "parent_id": "1773802501681", "name": "CS75", "sort": 0, "create_time": "2026-03-18T02:57:14.000Z" },
                                { "id": "1773802641659", "parent_id": "1773802501681", "name": "CS160", "sort": 0, "create_time": "2026-03-18T02:57:22.000Z" }
                            ]
                            },
                            {
                            "id": "1773802525877",
                            "parent_id": "1773802478479",
                            "name": "Ricambi Serie PY (Great Wall)",
                            "sort": 0,
                            "create_time": "2026-03-18T02:55:26.000Z",
                            "children": [
                                { "id": "1773802664373", "parent_id": "1773802525877", "name": "PY Serie 600", "sort": 0, "create_time": "2026-03-18T02:57:44.000Z" },
                                { "id": "1773802674895", "parent_id": "1773802525877", "name": "PY Serie 900", "sort": 0, "create_time": "2026-03-18T02:57:55.000Z" },
                                { "id": "1773802681411", "parent_id": "1773802525877", "name": "PY Serie 1200", "sort": 0, "create_time": "2026-03-18T02:58:01.000Z" }
                            ]
                            },
                            {
                            "id": "1773802533198",
                            "parent_id": "1773802478479",
                            "name": "Ricambi Serie CS (Great Wall)",
                            "sort": 0,
                            "create_time": "2026-03-18T02:55:33.000Z",
                            "children": [
                                { "id": "1773802693953", "parent_id": "1773802533198", "name": "CS75", "sort": 0, "create_time": "2026-03-18T02:58:14.000Z" },
                                { "id": "1773802699419", "parent_id": "1773802533198", "name": "CS160", "sort": 0, "create_time": "2026-03-18T02:58:19.000Z" },
                                { "id": "1773802706765", "parent_id": "1773802533198", "name": "CS240", "sort": 0, "create_time": "2026-03-18T02:58:27.000Z" }
                            ]
                            }
                        ]
                        },
                        {
                        "id": "1773802552021",
                        "parent_id": "1773802326100",
                        "name": "Frantoio a Impatto",
                        "sort": 0,
                        "create_time": "2026-03-18T02:55:52.000Z",
                        "children": [
                            { "id": "1773802574654", "parent_id": "1773802552021", "name": "PF1010", "sort": 0, "create_time": "2026-03-18T02:56:15.000Z" },
                            { "id": "1773802596236", "parent_id": "1773802552021", "name": "PF1210", "sort": 0, "create_time": "2026-03-18T02:56:36.000Z" },
                            { "id": "1773802602796", "parent_id": "1773802552021", "name": "PF1214", "sort": 0, "create_time": "2026-03-18T02:56:43.000Z" },
                            { "id": "1773802611526", "parent_id": "1773802552021", "name": "PF1315", "sort": 0, "create_time": "2026-03-18T02:56:52.000Z" }
                        ]
                        },
                        {
                        "id": "1773802735072",
                        "parent_id": "1773802326100",
                        "name": "Frantoio a Martelli",
                        "sort": 0,
                        "create_time": "2026-03-18T02:58:55.000Z",
                        "children": [
                            { "id": "1773802762524", "parent_id": "1773802735072", "name": "PC400x300", "sort": 0, "create_time": "2026-03-18T02:59:22.000Z" },
                            { "id": "1773802771517", "parent_id": "1773802735072", "name": "PC600x400", "sort": 0, "create_time": "2026-03-18T02:59:31.000Z" },
                            { "id": "1773802783876", "parent_id": "1773802735072", "name": "PC800x600", "sort": 0, "create_time": "2026-03-18T02:59:44.000Z" },
                            { "id": "1773802793253", "parent_id": "1773802735072", "name": "PC1000x800", "sort": 0, "create_time": "2026-03-18T02:59:53.000Z" },
                            { "id": "1773802802895", "parent_id": "1773802735072", "name": "PC1200x1000", "sort": 0, "create_time": "2026-03-18T03:00:03.000Z" }
                        ]
                        },
                        {
                        "id": "1773803720522",
                        "parent_id": "1773802326100",
                        "name": "Lavatrice per Sabbia",
                        "sort": 0,
                        "create_time": "2026-03-18T03:15:21.000Z",
                        "children": [
                            {
                            "id": "1773803741881",
                            "parent_id": "1773803720522",
                            "name": "Lavatrice a Coclea Serie LSX",
                            "sort": 0,
                            "create_time": "2026-03-18T03:15:42.000Z",
                            "children": [
                                { "id": "1773803773232", "parent_id": "1773803741881", "name": "LSX920", "sort": 0, "create_time": "2026-03-18T03:16:13.000Z" },
                                { "id": "1773803778021", "parent_id": "1773803741881", "name": "2LSX920", "sort": 0, "create_time": "2026-03-18T03:16:18.000Z" },
                                { "id": "1773803784278", "parent_id": "1773803741881", "name": "LSX1120", "sort": 0, "create_time": "2026-03-18T03:16:24.000Z" },
                                { "id": "1773803788977", "parent_id": "1773803741881", "name": "2LSX1120", "sort": 0, "create_time": "2026-03-18T03:16:29.000Z" }
                            ]
                            }
                        ]
                        }
                    ]
                    }
            ]
        }
    ]
}